<template>
  <nav
    class="mobile-bottom-nav"
    :style="{ '--mobile-nav-count': mobileNavCount }"
    :aria-label="$t('nav.mobilePrimary')"
  >
    <a
      v-for="item in navItems"
      :key="item.key"
      href="#"
      class="mobile-bottom-nav__item"
      :class="{ 'mobile-bottom-nav__item--active': activeKey === item.key }"
      @click.prevent="$emit('nav', item.key)"
    >
      <span class="mobile-bottom-nav__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false">
          <path
            v-for="(d, idx) in iconPaths(item.icon)"
            :key="idx"
            :d="d"
            fill="currentColor"
          />
        </svg>
      </span>
      <span class="mobile-bottom-nav__label">{{ item.label }}</span>
    </a>
  </nav>
</template>

<script>

const ICON_PATHS = {
  home: ['M12 3.2 4 10v10h6v-6h4v6h6V10l-8-6.8z'],
  live: ['M6 5h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zm0 4.5 4.5 3L18 9.5V7L10.5 12 6 9.5v-.5z'],
  slots: [
    'M5 7h3v10H5V7zm5.5 0H14v10h-3.5V7zM16 7h3v10h-3V7z',
    'M4 5h16a1 1 0 0 1 1 1v1H3V6a1 1 0 0 1 1-1z'
  ],
  sports: ['M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm-1.2 4.2 5.2 3-5.2 3V7.2z'],
  minigames: [
    'M6 5.5h12v12H6v-12zm2 2v2h2v-2H8zm4 0v2h2v-2h-2zm-4 4v2h2v-2H8zm4 0v2h2v-2h-2z'
  ],
  fishing: [
    'M4 12c2.8-3.6 6.2-5.5 10-5.8 1.4 2.2 3.2 3.8 5.4 4.6-1.2.8-2.4 1.2-3.6 1.2H12l-1.8 2.2c-.8.9-1.8 1.4-2.9 1.4-2 0-3.3-1.6-3.3-3.4z',
    'M18.5 8.5l1.5 1.6-1.3 1.1-1.6-1.4.4-1.3z'
  ]
}

export default {
  name: 'BlackGoldMobileNav',
  props: {
    activeKey: { type: String, default: 'home' },
    navItems: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    mobileNavCount () {
      return this.navItems.length || 1
    }
  },
  methods: {
    iconPaths (icon) {
      return ICON_PATHS[icon] || ICON_PATHS.home
    }
  }
}
</script>
